module.exports = __webpack_public_path__ + "static/media/tractor-128.3fb91afb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tractor-128.png
// module id = 459
// module chunks = 0